export default {
  title: 'Anmod om sletning af data for {{name}}',
  description:
    'Dette opretter en GDPR-anmodning om datasletning. En administrator skal godkende den, før kundens data slettes permanent.',
  form: {
    note: {
      label: 'Note',
      placeholder: 'Tilføj kontekst til anmodningen (valgfrit)',
    },
  },
  buttons: {
    confirm: 'Anmod om sletning',
  },
  toasts: {
    success: 'Anmodning om datasletning oprettet',
    error: 'Anmodningen om datasletning kunne ikke oprettes',
  },
};
